import React from 'react';

import TestTerms from '../../../../containers/TestTerms';

import { UnderwriterProps } from '../../../../types/TermsTypes';

const TestIndex: React.FC<UnderwriterProps> = (props) => {
  const { contractTerms } = props;
  let Terms: any;
  switch (contractTerms.termsKey) {
    case 'test':
    default:
      Terms = <TestTerms />;
      break;
  }

  return Terms;
};

export default TestIndex;
